import React from 'react';
import { Typography as PdcTypography } from '@mzc-pdc/ui';
import { TypographyProps } from './infrastructures/TypographyProps';

export const H4 = (props: TypographyProps) => (
  <PdcTypography variant={'h4'} component={'h4'} align={props.centered ? 'center' : undefined}>
    {props.children}
  </PdcTypography>
);
